import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { RedesignCheckout } from 'widget/event_components/Checkout/views/redesign/checkout';
import { DefaultCheckout } from './views/default';

const CheckoutController = (props) => {
  if (!props.event || !props.settings) return null;
  if (props.variant === 'redesign') return <RedesignCheckout {...props} />;
  return <DefaultCheckout {...props} />;
};

CheckoutController.propTypes = {
  variant: PropTypes.oneOf(['default', 'redesign']).isRequired,
  event: PropTypes.instanceOf(Map),
  settings: PropTypes.instanceOf(Map),
};

export default CheckoutController;
